import { useSubscriptionStatus } from '@/hooks/use-subscription-status';
import { CatalogSlide } from './CatalogSlide';
import { InstrumentsSlide } from './InstrumentsSlide';
import { PrivacySlide } from './PrivacySlide';
import { SubscriptionCTASlide } from './SubscriptionCTASlide';
import { WelcomeSlide } from './WelcomeSlide';
import type { ComponentType } from 'react';

interface HeroSlide {
    id: string;
    component: ComponentType;
}

export function useDashboardSlides(): HeroSlide[] {
    const { hasSubscription } = useSubscriptionStatus();

    const slides: HeroSlide[] = [{ id: 'welcome', component: WelcomeSlide }];

    // Second is the most-seen slot after the first, so the upgrade ask keeps it.
    if (!hasSubscription) {
        slides.push({
            id: 'subscription-cta',
            component: SubscriptionCTASlide,
        });
    }

    slides.push(
        { id: 'catalog', component: CatalogSlide },
        { id: 'instruments', component: InstrumentsSlide },
        { id: 'privacy', component: PrivacySlide },
    );

    return slides;
}
